import React, { Component } from 'react'
import { Col, Row, Button, Input, Label } from 'reactstrap'
import PropTypes from 'prop-types'

export default class ConvertInput extends Component {
  constructor(props) {
    super(props)
    const defaultMm = props.existingValue != null
      ? props.existingValue
      : props.defaultValue ? Math.round(props.my_value * (props.defaultValue / 100)) : 0
    this.state = {
      millimeters: defaultMm,
      selected: 'category'
    }
  }

  static propTypes = {
    existingValue: PropTypes.number,
    defaultValue: PropTypes.number,
    onMillimetersChange: PropTypes.func,
    multipleWelds: PropTypes.bool,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue || nextProps.my_value !== this.props.my_value) {
      const mm = nextProps.defaultValue ? Math.round(nextProps.my_value * (nextProps.defaultValue / 100)) : 0
      this.setState({ millimeters: mm, selected: 'category' })
      nextProps.onMillimetersChange && nextProps.onMillimetersChange(mm)
    }
  }

  getPercent() {
    return Math.round((this.state.millimeters * 100) / this.props.my_value)
  }

  handleClick = (type) => {
    if (!this.props.multipleWelds) {
      const percent = type === '100' ? 100 : this.props.defaultValue
      const mm = Math.round((this.props.my_value * percent) / 100)
      this.setState({ millimeters: mm, selected: type })
      this.props.onMillimetersChange && this.props.onMillimetersChange(mm)
    } else {
      this.setState({ selected: type })
    }
  }

  render() {
    const { my_value, defaultValue, multipleWelds } = this.props
    const { millimeters, selected } = this.state
    const percent = this.getPercent()
    const categoryMm = defaultValue ? Math.round(my_value * (defaultValue / 100)) : 0

    const completePercentValue = multipleWelds
      ? (selected === '100' ? '100' : 'as-per-insp-cat')
      : ''

    return (
      <div>
        {!multipleWelds && (
          <Row>
            <Col xs="12" sm="4">
              <Label>Millimeters:</Label>
              <Input
                name="complete"
                value={millimeters}
                onChange={(e) => {
                  const mm = Number(e.target.value) || 0
                  this.setState({ millimeters: mm, selected: mm === categoryMm ? 'category' : mm === my_value ? '100' : 'custom' })
                  this.props.onMillimetersChange && this.props.onMillimetersChange(mm)
                }}
                type="number"
                min={1}
                required
              />
            </Col>
            <Col xs="12" sm="8" style={{ display: 'flex', alignItems: 'flex-end', gap: '5px', paddingBottom: '1px' }}>
              <Button type="button" style={{ flex: 3 }}
                color={selected === 'category' ? 'primary' : 'secondary'}
                onClick={() => this.handleClick('category')}
              >
                As per insp. cat.
              </Button>
              <Button type="button" style={{ flex: 1 }}
                color={selected === '100' ? 'primary' : 'secondary'}
                onClick={() => this.handleClick('100')}
              >
                100%
              </Button>
            </Col>
          </Row>
        )}
        {multipleWelds && (
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button type="button" style={{ flex: 3 }}
              color={selected === 'category' ? 'primary' : 'secondary'}
              onClick={() => this.handleClick('category')}
            >
              As per insp. cat.
            </Button>
            <Button type="button" style={{ flex: 1 }}
              color={selected === '100' ? 'primary' : 'secondary'}
              onClick={() => this.handleClick('100')}
            >
              100%
            </Button>
          </div>
        )}
        {!multipleWelds && (
          <div style={{ marginTop: '5px' }}>
            <small className="text-muted">{millimeters} mm is <strong>{percent}%</strong> of weld length</small>
          </div>
        )}
        <Input type="hidden" name="complete_percent" value={completePercentValue} />
        {multipleWelds && <Input type="hidden" name="complete" value="" />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EventLog/ConvertInput.js